import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Column } from "@ant-design/plots";
import { useSelector } from "react-redux";
import { FlexColumn } from "../../styles/Global";

export const ColumnPlot = ({
  data,
  customConfig,
  style,
  x,
  y,
  seriesField,
}) => {
  const darkMode = useSelector((state) => state.global.darkMode);
  console.log("columnPlot data: ", data);
  console.log("columnPlot x: ", x);
  console.log("columnPlot y: ", y);
  const config = customConfig
    ? customConfig
    : {
        data,
        xField: x ? x : "key_as_string",
        yField: y ? y : "doc_count",
        seriesField: "",
        padding: [30, 5, 20, 32],
        label: {
          position: "top",
          style: {
            fill: darkMode ? "#fff" : "#000",
            opacity: 1,
            fontSize: ".6em",
          },
          content: (item) => {
            return `${item.percent}`;
          },
        },
      };
  return data && data.length > 0 ? (
    <Column style={style} autoFit={true} {...config} />
  ) : null;
};

export default ColumnPlot;
